module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm"
  }, [_c('div', {
    staticClass: "box-bordered p-l-10 p-r-10 p-b-10"
  }, [_c('table', {
    attrs: {
      "width": "100%"
    }
  }, [_c('tbody', _vm._l((_vm.users), function(user) {
    return _c('PrintList', {
      attrs: {
        "children": user.children,
        "user": user.user
      }
    })
  }), 1)])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-34cb1a98!./~/vue-loader/lib/selector.js?type=template&index=0!./app/components/ia/Structure.vue
// module id = 1096
// module chunks = 0